import React, { useState } from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import { Container, Form } from './styles';
import Button from '../Button';
import DarkInput from '../DarkInput';

import { validateEmail } from '../../utils/validators';
import request from '../../services';
import { getFirstAndLastName } from '../../utils/helper';

function QuestionForm({ submitCallback }) {
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    name: '',
    email: '',
    question: '',
  };

  const validate = values => {
    const errors = {};

    if (!values.name) {
      errors.name = 'Requerido';
    } else if (values.name.length < 4) {
      errors.name = 'Insira no mínimo 4 caracteres';
    }

    if (!values.email) {
      errors.email = 'Requerido';
    } else if (!validateEmail(values.email)) {
      errors.email = 'Email inválido';
    }

    if (!values.question) {
      errors.question = 'Requerido';
    } else if (values.question.length < 15) {
      errors.question = 'Pelo menos 15 caracteres';
    }

    return errors;
  };

  const onSubmit = values => {
    const { name, email, question } = values;

    const { firstName, lastName } = getFirstAndLastName(name);

    const form = new FormData();
    form.append('mauticform[formId]', '19');
    form.append('mauticform[formName]', '11_LP Parceiros Precatórios Dúvidas');
    form.append('mauticform[nome]', firstName);
    form.append('mauticform[sobrenome]', lastName);
    form.append('mauticform[email]', email);
    form.append('mauticform[pergunta_parceiros]', question);

    request({
      url: 'https://precatorios.decode.buzz/mautic/index.php/form/submit',
      method: 'POST',
      data: form,
      loaderSetterFunction: setIsLoading,
    }).then(() => {
      formik.resetForm();
      submitCallback(true);
    });
  };

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit,
  });

  return (
    <Container>
      <Form onSubmit={formik.handleSubmit}>
        <DarkInput
          id="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          placeholder="Nome"
          error={formik.errors.name}
          dark
        />
        <DarkInput
          id="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          placeholder="Email"
          error={formik.errors.email}
          dark
        />
        <DarkInput
          id="question"
          value={formik.values.question}
          onChange={formik.handleChange}
          placeholder="DÚVIDA"
          error={formik.errors.question}
          dark
        />
        <Button isLoading={isLoading} primary blackText>
          {isLoading ? 'Enviando' : 'Enviar dúvidas'}
        </Button>
      </Form>
    </Container>
  );
}

QuestionForm.propTypes = {
  submitCallback: PropTypes.func.isRequired,
};

export default QuestionForm;
